'use client';

import { useEffect, useState } from 'react';

// Invisible [data-stone] position anchors. The WebGL shader draws the visible
// stones; these divs only exist so stoneRects.readStoneRects() can measure
// where the stones sit (and so they track scroll/resize). Positions mirror the
// prior zen composition; stones whose center would fall inside the content
// column (max-w-content, centered) are pushed toward the viewport edge.

type Anchor = { id: string; xFrac: number; yFrac: number; w: number; h: number };

const ANCHORS: Anchor[] = [
  { id: 'a', xFrac: 0.10, yFrac: 0.72, w: 150, h: 88 },
  { id: 'b', xFrac: 0.92, yFrac: 0.86, w: 170, h: 84 },
  { id: 'c', xFrac: 0.86, yFrac: 0.28, w: 104, h: 74 },
];

export function SandStoneAnchors() {
  const [vw, setVw] = useState(0);
  const [vh, setVh] = useState(0);

  useEffect(() => {
    const measure = () => { setVw(window.innerWidth); setVh(window.innerHeight); };
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, []);

  if (vw === 0) return null;

  // content column is centered with a max width; keep stone centers outside it
  const colHalf = Math.min(vw * 0.5, 640); // matches max-w-content (~1280px)
  const colLeft = vw / 2 - colHalf;
  const colRight = vw / 2 + colHalf;

  return (
    <div aria-hidden="true" style={{ position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 0 }}>
      {ANCHORS.map((a) => {
        let cx = a.xFrac * vw;
        const cy = a.yFrac * vh;
        // push center to the nearer edge if it lands inside the content column
        if (cx > colLeft && cx < colRight) {
          cx = cx < vw / 2 ? Math.max(a.w / 2, colLeft - a.w * 0.2) : Math.min(vw - a.w / 2, colRight + a.w * 0.2);
        }
        return (
          <div
            key={a.id}
            data-stone
            style={{
              position: 'absolute',
              left: cx - a.w / 2,
              top: cy - a.h / 2,
              width: a.w,
              height: a.h,
              opacity: 0,
            }}
          />
        );
      })}
    </div>
  );
}
